<template>
  <div class="weekly-report">
    <van-sticky>
      <children @change="childChange" />
    </van-sticky>

    <div class="body" v-if="loaded">
      <template v-if="weeks.length > 0">
        <div class="filter-bar">
          <div class="year" @click="yearShow = true">
            <span>{{ $t('weeklyReport.school_year', { year: currentYearTitle }) }}</span>
            <img src="@/assets/weeklyReport/down.svg" width="12" height="12" alt="" />
          </div>
        </div>
        <div class="grid">
          <div class="card" v-for="item in weeks" :key="item.week" @click="toDetail(item)">
            <div class="cover" :class="{ empty: !item.cover }">
              <img v-if="item.cover" :src="item.cover" class="cover-img" alt="" />
              <span v-else class="no-photo">{{ $t('weeklyReport.no_photo') }}</span>
              <span class="tag">
                <img src="@/assets/weeklyReport/photo-count.svg" width="12" height="12" alt="" />
                {{ item.photo_num }}
              </span>
            </div>
            <div class="week">Week {{ pad(item.week) }}</div>
            <div class="date">{{ item.start_date }} - {{ item.end_date }}</div>
          </div>
        </div>
      </template>
      <van-empty v-else :description="$t('weeklyReport.empty')" />
    </div>

    <van-action-sheet
      v-model="yearShow"
      :actions="yearActions"
      :cancel-text="$t('global.cancel')"
      close-on-click-action
      @select="yearSelect" />
  </div>
</template>

<script>
import Vue from 'vue'
import { Sticky, ActionSheet, Empty } from 'vant'
import Children from '@/components/Children'
import { weeklyReportList } from '@/api/weeklyReport'

Vue.use(Sticky)
Vue.use(ActionSheet)
Vue.use(Empty)

export default {
  name: 'WeeklyReport',
  components: { Children },
  data () {
    return {
      childId: 0,
      yid: 0,
      years: [],
      weeks: [],
      loaded: false,
      yearShow: false,
    }
  },
  computed: {
    currentYearTitle () {
      const year = this.years.find(item => item.yid == this.yid)
      return year ? year.title : ''
    },
    yearActions () {
      return this.years.map(item => ({
        name: this.$t('weeklyReport.school_year', { year: item.title }),
        yid: item.yid,
        color: item.yid == this.yid ? '#1989FA' : '',
      }))
    },
  },
  methods: {
    childChange (child) {
      const isFirst = !this.childId
      if (child.id == this.childId) return
      this.childId = child.id
      // 首次进入时保留地址栏上的学年（从详情返回），切换孩子后重置
      this.yid = isFirst ? (this.$route.query.yid || 0) : 0
      this.fetchData()
    },
    fetchData () {
      weeklyReportList({ child_id: this.childId, yid: this.yid }).then(res => {
        if (res.code != 0) return
        this.years = res.data.years
        this.yid = res.data.yid
        this.weeks = res.data.weeks
        this.loaded = true
        this.syncQuery()
      })
    },
    yearSelect (item) {
      if (item.yid == this.yid) return
      this.yid = item.yid
      this.fetchData()
    },
    syncQuery () {
      const query = { ...this.$route.query, childid: String(this.childId), yid: String(this.yid) }
      if (query.childid === this.$route.query.childid && query.yid === this.$route.query.yid) return
      this.$router.replace({ query }).catch(() => {})
    },
    toDetail (item) {
      this.$router.push({
        name: 'WeeklyReportDetail',
        query: { childid: this.childId, yid: this.yid, week: item.week },
      })
    },
    pad (week) {
      return String(week).padStart(2, '0')
    },
  },
}
</script>

<style lang="less" scoped>
.weekly-report {
  min-height: 100vh;
  background: #F5F6F8;
}
.body {
  padding: 12px;
}
.filter-bar {
  margin-bottom: 12px;
  .year {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    line-height: 18px;
    color: #323233;
  }
}
.grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}
.card {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px;
  background: #FFFFFF;
  border-radius: 12px;
}
.cover {
  position: relative;
  height: 88px;
  border-radius: 8px;
  overflow: hidden;
  &.empty {
    background: #F5F6F8;
  }
  .cover-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
  .no-photo {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 12px;
    color: #C8C9CC;
    white-space: nowrap;
  }
  .tag {
    position: absolute;
    right: 8px;
    bottom: 8px;
    display: flex;
    align-items: center;
    gap: 2px;
    height: 16px;
    padding: 0 4px;
    border-radius: 4px;
    background: rgba(0, 0, 0, 0.5);
    font-size: 11px;
    line-height: 16px;
    color: #FFFFFF;
  }
}
.week {
  font-size: 14px;
  font-weight: 500;
  color: #323233;
}
.date {
  margin-top: -10px; // 设计稿标题与日期间距 2px（卡片 gap 为 12px）
  font-size: 12px;
  line-height: 18px;
  color: #969799;
}
</style>
